"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _DateWeek = _interopRequireDefault(require("./DateWeek"));
var _DateMonth = _interopRequireDefault(require("./DateMonth"));
var _DateDay = _interopRequireDefault(require("./DateDay"));
var _DateRange = _interopRequireDefault(require("./DateRange"));
var _react = _interopRequireDefault(require("react"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/OutputTable/Search/DateType.js";
function DateType(_ref) {
  var field = _ref.field,
    type = _ref.type,
    onChange = _ref.onChange;
  _react["default"].useEffect(function () {
    return function () {
      return onChange({});
    };
  }, []);
  switch (type) {
    case 'Daily':
      return /*#__PURE__*/_react["default"].createElement(_DateDay["default"], {
        field: field,
        onChange: onChange,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 13,
          columnNumber: 20
        }
      });
    case 'Weekly':
      return /*#__PURE__*/_react["default"].createElement(_DateWeek["default"], {
        field: field,
        onChange: onChange,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 18,
          columnNumber: 20
        }
      });
    case 'Monthly':
      return /*#__PURE__*/_react["default"].createElement(_DateMonth["default"], {
        field: field,
        onChange: onChange,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23,
          columnNumber: 20
        }
      });
    case 'Custom':
      return /*#__PURE__*/_react["default"].createElement(_DateRange["default"], {
        field: field,
        onChange: onChange,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28,
          columnNumber: 20
        }
      });
  }
}
var _default = DateType;
exports["default"] = _default;